<div class="air-details-container">

    <div class="section-title">{{searchPageTitle}} - Build Search
    </div>
    <div class="partioned-table">
        <div class="row" *ngIf="showDateRange">
            <div class="cell label label-text">Date Range
            </div>
            <div class="cell value"> <p-checkbox label="Last 7 days" [(ngModel)]="filters.dateRangeChecked"
                    binary="true">

                </p-checkbox>
                <ng-container *ngIf="!filters.dateRangeChecked">
                    <div class="date-row">
                        <span class="date-label">Start Date:</span>
                        <p-calendar  [showIcon]="true" [(ngModel)]="filters.startDate" dateFormat="mm/dd/yy" [style]="{'width':'20%'}"></p-calendar>
                    </div>
                    <div class="date-row">
                        <span class="date-label">To Date:</span>
                        <p-calendar  [showIcon]="true" [(ngModel)]="filters.endDate" dateFormat="mm/dd/yy" [style]="{'width':'20%'}"></p-calendar>
                    </div>
                </ng-container>
            </div>
        </div>
        <div class="row">
            <div class="cell label label-text">Repair Type
            </div>
            <div class="cell value"> <p-dropdown [options]="repairTypes" [(ngModel)]="filters.repairType"
                    placeholder="ALL" class="dropdown" class="custom-dropdown"
                    panelStyleClass="custom-dropdown-panel"
                    optionLabel="name" optionValue="value" (onChange)="onDropDownChange($event,'repairType')"
                     ></p-dropdown>
            </div>
        </div>
        <div class="row">
            <div class="cell label label-text">Division
            </div>
            <div class="cell value">
                <p-dropdown [options]="divisions" [(ngModel)]="filters.division"
                    placeholder="ALL" class="dropdown" class="custom-dropdown"
                     optionLabel="name" optionValue="value" (onChange)="onDropDownChange($event,'division')"></p-dropdown>
            </div>
        </div>
        <div class="row">
            <div class="cell label label-text">Section
            </div>
            <div class="cell value">
                <p-dropdown [options]="section" [(ngModel)]="filters.section"
                    placeholder="ALL" class="dropdown" class="custom-dropdown"
                     optionLabel="name" optionValue="value" (onChange)="onDropDownChange($event,'section')"></p-dropdown>
            </div>
        </div>
        <div class="row">
            <div class="cell label label-text">Plant
            </div>
            <div class="cell value">
                <p-dropdown [options]="plant" [(ngModel)]="filters.plant"
                    placeholder="ALL" class="dropdown" class="custom-dropdown"
                     optionLabel="name" optionValue="value" (onChange)="onDropDownChange($event,'plant')"></p-dropdown>
            </div>
        </div>
        <div class="row">
            <div class="cell label label-text">Associated Plant - Shut down
            </div>
            <div class="cell value">
                <p-dropdown [options]="associatedUnit" [(ngModel)]="filters.associatedUnit"
                    placeholder="ALL" class="dropdown" class="custom-dropdown"
                     optionLabel="name" optionValue="value" (onChange)="onDropDownChange($event,'associatedUnit')"></p-dropdown>
            </div>
        </div>

        
        <div class="row">
            <div class="cell label label-text">LDAR
            </div>
            <div class="cell value">
                <p-dropdown [options]="ldar" [(ngModel)]="filters.ldar"
                    placeholder="ALL" class="dropdown" class="custom-dropdown"
                     optionLabel="name" optionValue="value" (onChange)="onDropDownChange($event,'ldar')"></p-dropdown>
            </div>
        </div>
        <div class="row">
            <div class="cell label label-text">Component
            </div>
            <div class="cell value">
                <p-dropdown [options]="manageLeaksItems" [(ngModel)]="filters.manageLeaksItems"
                    placeholder="ALL" class="dropdown" class="custom-dropdown"
                     optionLabel="name" optionValue="value" (onChange)="onDropDownChange($event,'manageLeaksItems')"></p-dropdown>
            </div>
        </div>
        <div class="row">
            <div class="cell label label-text">Vapor/Liquid
            </div>
            <div class="cell value">
                <p-dropdown [options]="materialStateItems" [(ngModel)]="filters.materialStateItems"
                    placeholder="ALL" class="dropdown" class="custom-dropdown"
                     optionLabel="name" optionValue="value" (onChange)="onDropDownChange($event,'materialStateItems')"></p-dropdown>
            </div>
        </div>

        <div class="row">
            <div class="cell label label-text">Services
            </div>
            <div class="cell value">
                <div class="services-option" *ngFor="let service of services">
                    <p-checkbox [inputId]="service.value" name="services.label" [value]="service.value"
                        [(ngModel)]="filters.selctedServices"></p-checkbox>
                    <label [for]="service.label">{{service.label}}</label>
                </div>
            </div>
        </div>

    </div>
    <div class="button-row">
        <button class="cursor-pointer" (click)="runReport()">Run Report</button>
    </div>
</div>